import { render, staticRenderFns } from "./ShowDocument.vue?vue&type=template&id=47b8940b&scoped=true&"
import script from "./ShowDocument.vue?vue&type=script&lang=js&"
export * from "./ShowDocument.vue?vue&type=script&lang=js&"
import style0 from "./ShowDocument.vue?vue&type=style&index=0&id=47b8940b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8940b",
  null
  
)

export default component.exports